const guessContentType = (fileName) => {
  const ext = fileName?.split(".").pop()?.toLowerCase()
  switch (ext) {
    case "png": return "image/png"
    case "gif": return "image/gif"
    case "webp": return "image/webp"
    case "jpg":
    case "jpeg":
    default: return "image/jpeg"
  }
}

export const resourceToSrc = (resource, fileName, contentType) => {
  if (!resource) return null

  if (typeof resource === "string" && resource.startsWith("data:")) {
    return resource
  }

  if (typeof resource === "string") {
    const type = contentType || guessContentType(fileName);
    return `data:${type};base64,${resource}`
  }

  if (resource && typeof resource === "object") {
    const dataArray = Array.isArray(resource)
      ? new Uint8Array(resource)
      : resource.data
        ? new Uint8Array(resource.data)
        : null

    if (dataArray) {
      const blob = new Blob([dataArray], { type: contentType || guessContentType(fileName) })
      return URL.createObjectURL(blob)
    }
  }

  return null
}

export const toPictureTypeLabelRo = (pictureType) => {
  switch (pictureType) {
    case 'TRUCK_TEMPERATURE':
      return 'Temperatură'
    case 'TRUCK_NOTICE':
      return 'Aviz'
    default:
      return 'Tip necunoscut'
  }
}
